import { render, staticRenderFns } from "./ProgressPie.vue?vue&type=template&id=4fd5700f&scoped=true&"
import script from "./ProgressPie.vue?vue&type=script&lang=js&"
export * from "./ProgressPie.vue?vue&type=script&lang=js&"
import style0 from "./ProgressPie.vue?vue&type=style&index=0&id=4fd5700f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5700f",
  null
  
)

export default component.exports